import React from "react";
import {
    Chart,
    ChartArea,
    ChartLegend,
    ChartSeries,
    ChartSeriesItem,
    ChartXAxis,
    ChartYAxis,
    ChartXAxisItem,
    ChartYAxisItem,
    ChartTooltip,
} from "@progress/kendo-react-charts";

interface IPRGraphData {
    wiggins: { liquidRate: number; fbhp: number }[];
    vogel: { liquidRate: number; fbhp: number }[];
    constantPi: { liquidRate: number; fbhp: number }[];
    compositePi: { liquidRate: number; fbhp: number }[];
    x_Plot_MaxValue: number;
    y_PlotMaxValue: number;
    x_Plot_Interval: number;
    y_Plot_Interval: number;
}

interface IPRCurveGraphProps {
    data: IPRGraphData;
}

const IPRCurveGraph: React.FC<IPRCurveGraphProps> = ({ data }) => {
    if (!data) return <div>No data available</div>;

    return (
        <Chart>
            <ChartArea background="transparent" />

            {/* Legend */}
            <ChartLegend
                position="bottom"
                labels={{ font: "16px Mulish", color: "#fff" }}
            />

            {/* Series */}
            <ChartSeries>
                <ChartSeriesItem
                    name="Wiggins"
                    type="scatterLine"
                    data={data.wiggins}
                    xField="liquidRate"
                    yField="fbhp"
                    color="orange"
                    markers={{ visible: true }}
                    width={4.0}
                    tooltip={{ visible: true, format: "{0} x {1}" }}
                />
                <ChartSeriesItem
                    name="Vogel"
                    type="scatterLine"
                    data={data.vogel}
                    xField="liquidRate"
                    yField="fbhp"
                    color="#0000FF"
                    markers={{ visible: true }}
                    width={4.0}
                    tooltip={{ visible: true, format: "{0} x {1}" }}
                />
                <ChartSeriesItem
                    name="Gilbert"
                    type="scatterLine"
                    data={data.constantPi}
                    xField="liquidRate"
                    yField="fbhp"
                    color="#FF0000"
                    markers={{ visible: true }}
                    width={4.0}
                    tooltip={{ visible: true, format: "{0} x {1}" }}
                />
                <ChartSeriesItem
                    name="Composite"
                    type="scatterLine"
                    data={data.compositePi}
                    xField="liquidRate"
                    yField="fbhp"
                    color="#006633"
                    markers={{ visible: true }}
                    width={4.0}
                    tooltip={{ visible: true, format: "{0} x {1}" }}
                />
            </ChartSeries>

            {/* X Axis */}
            <ChartXAxis>
                <ChartXAxisItem
                    title={{ text: `Liquid Rate [STB / D]`, font: "16px Mulish",  color: "#fff",  }}
                    color="#fff"
                    majorGridLines={{ width: 0.8, color: "#A0A0A0" }}
                    minorGridLines={{ width: 0.3, color: "#A0A0A0", visible: false }}
                    crosshair={{ visible: true, width: 1, color: "#005F7C" }}
                    min={0}
                    // max={data.x_Plot_MaxValue}
                />
            </ChartXAxis>

            {/* Y Axis */}
            <ChartYAxis>
                <ChartYAxisItem
                    name="FBHP"
                    title={{ text: `Flowing Bottomhole Pressure [PSI]`,font: "16px Mulish",  color: "#fff", }}
                    min={0}
                    // max={data.y_PlotMaxValue}
                    color="#fff"
                    majorGridLines={{ width: 0.8, color: "#A0A0A0", step:2}}
                    minorGridLines={{ width: 0.3, color: "#A0A0A0", visible: false }}
                    crosshair={{ visible: true, width: 1, color: "#005F7C" }}
                />
            </ChartYAxis>

            {/* Tooltip */}
            <ChartTooltip visible={true} />
        </Chart>
    );
};

export default React.memo(IPRCurveGraph);
